import styled from '@emotion/styled';

export const PageWrapper = styled.div`
  display: grid;
  max-width: 1400px;
  margin: 0 auto;
  place-items: center;
`;
